import { connect } from 'react-redux';
import CreateChannel from '../../components/CreateChannel';
import { startChannel, clearError } from '../../actions/chatActions';
import { START_CHANNEL } from '../../constants/ActionTypes'

const mapStateToProps = state => ({
  createChannelError: state.errors[START_CHANNEL]
});

const mapDispatchToProps = dispatch => ({
  startChannel: ({ name, isPrivate, userIds }) => dispatch(startChannel(name, isPrivate, userIds)),
  clearError: type => dispatch(clearError(type))
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateChannel);
